import { SxProps, Theme } from '@mui/material/styles';

const DP_BLUE = '#2682E7';
const DP_BLUE_HOVER = '#0467D2';

export const repurchaseCtaRootSX: SxProps<Theme> = {
	width: '100vw',
	py: { xs: '32px', md: '72px' },
	px: '16px',
	boxSizing: 'border-box',
	background: '#F4F9FF',
	display: 'flex',
	justifyContent: 'center',
};

export const repurchaseCtaInnerSX: SxProps<Theme> = {
	maxWidth: '560px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: { xs: '12px', md: '14px' },
	textAlign: 'center',
};

export const repurchaseCtaTitleSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '24px', md: '32px' },
	fontWeight: 800,
	lineHeight: 1.15,
	textTransform: 'uppercase',
	color: '#2c2c2c',
};

export const repurchaseCtaTextSX: SxProps<Theme> = {
	m: 0,
	fontSize: { xs: '14px', md: '15px' },
	lineHeight: 1.45,
	color: '#505050',
};

export const repurchasePillButtonSX = {
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: { xs: '12px 24px', md: '13px 28px' },
	borderRadius: '999px',
	fontFamily: 'inherit',
	fontSize: '14px',
	fontWeight: 700,
	lineHeight: 1.5,
	letterSpacing: '0.02em',
	textTransform: 'uppercase',
	textDecoration: 'none',
} as const;

export const repurchaseCtaButtonSX: SxProps<Theme> = {
	...repurchasePillButtonSX,
	mt: '4px',
	background: DP_BLUE,
	color: '#FFFFFF',
	'&:hover, &:focus-visible': { background: DP_BLUE_HOVER, textDecoration: 'none' },
};

export const repurchaseCtaValiditySX: SxProps<Theme> = {
	m: 0,
	fontSize: '12px',
	color: '#6b6b6b',
};

export const repurchaseCtaValidityStrongSX: SxProps<Theme> = {
	fontWeight: 700,
	color: '#505050',
};
